import AnnouncementsContainer from './Announcements';

const Announcements = AnnouncementsContainer;
export default Announcements;
